module.exports = __webpack_public_path__ + "img/65.720de743.jpg";